/* global document */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { defaultAspects, contentTopBiases } from './Header1';
import Header from './Header';
import { menuType } from '../../propTypes';
import {
  getSliceActiveMenuIndex,
  getSliceMenu,
  getSliceMenuOverlayIsBlack,
} from '../../selectors';
import Caption from './HeaderCaption';
import Menu from './Menu';
import theme, { makeResponsiveSettings } from '../../styles/theme';
import {
  menuToggledCreator,
  menuActivatedCreator,
  menuDeactivatedCreator,
} from '../../actions';

class HubHeader extends PureComponent {
  menuClickTesters = [];

  constructor(props, context) {
    super(props, context);
    const bodyClickToggler = method => () => ['click', 'touchstart'].forEach(event => (
      document.body[method](event, this.onBodyClick)
    ));
    this.closeMenuOnBodyClick = bodyClickToggler('addEventListener');
    this.ignoreBodyClick = bodyClickToggler('removeEventListener');
  }

  componentDidMount() {
    const { menuIsActive } = this.props;
    if (menuIsActive) {
      this.closeMenuOnBodyClick();
    }
  }

  componentDidUpdate(prevProps) {
    const { menuIsActive } = this.props;
    if (menuIsActive !== prevProps.menuIsActive) {
      if (menuIsActive) {
        this.closeMenuOnBodyClick();
      } else {
        this.ignoreBodyClick();
      }
    }
  }

  componentWillUnmount() {
    const { menuIsActive } = this.props;
    if (menuIsActive) {
      document.body.removeEventListener('click', this.onBodyClick);
    }
  }

  onBodyClick = e => {
    const { onMenuClick, menuIsActive } = this.props;
    if (onMenuClick && menuIsActive && !this.menuClickTesters.find(
      clickTester => clickTester(e.target),
    )) {
      onMenuClick(-1);
    }
  };

  receiveMenuClickTester = clickTester => {
    this.menuClickTesters.push(clickTester);
  };

  render() {
    const {
      activeMenuIndex, classes, menu, sliceId,
      onMenuActivated, onMenuDeactivated, ...props
    } = this.props;
    return (
      <Header
        defaultAspects={defaultAspects}
        contentTopBiases={contentTopBiases}
        overlay={<Caption sliceId={sliceId} topBiases={contentTopBiases} />}
        navigationClassName={classes.navigation}
        navItems={menu.map((menuItem, i) => (
          <Menu
            key={i} // eslint-disable-line react/no-array-index-key
            menu={menuItem}
            onMenuActivated={() => onMenuActivated(i)}
            onMenuDeactivated={() => onMenuDeactivated(i)}
            open={activeMenuIndex === i}
            receiveClickTester={this.receiveMenuClickTester}
          />
        ))}
        sliceId={sliceId}
        {...props}
      />
    );
  }
}

HubHeader.propTypes = {
  activeMenuIndex: PropTypes.number.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  menu: PropTypes.arrayOf(menuType).isRequired,
  menuIsActive: PropTypes.bool.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  onMenuActivated: PropTypes.func.isRequired,
  onMenuDeactivated: PropTypes.func.isRequired,
  sliceId: PropTypes.number.isRequired,
};

HubHeader.defaultProps = {
};

const mapStateToProps = (state, { sliceId }) => {
  const activeMenuIndex = getSliceActiveMenuIndex(state, sliceId);
  return {
    activeMenuIndex,
    menu: getSliceMenu(state, sliceId),
    menuIsActive: activeMenuIndex >= 0,
    menuOverlayIsBlack: getSliceMenuOverlayIsBlack(state, sliceId),
  };
};

const mapDispatchToProps = (dispatch, { sliceId }) => ({
  onMenuClick: menuIndex => dispatch(menuToggledCreator(sliceId, menuIndex)),
  onMenuActivated: menuIndex => dispatch(menuActivatedCreator(sliceId, menuIndex)),
  onMenuDeactivated: menuIndex => dispatch(menuDeactivatedCreator(sliceId, menuIndex)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet({
    navigation: {
      [theme.breakpoints.only('sm')]: {
        flexDirection: 'row',
        alignItems: 'flex-end',
      },
      ...makeResponsiveSettings([
        'color', 'menuOverlayIsBlack', (menuOverlayIsBlack, { menuIsActive }) => {
          if (menuIsActive) {
            return menuOverlayIsBlack ? theme.colors.white : theme.colors.text;
          }
          return 'inherit';
        },
      ]),
    },
  }),
)(HubHeader);
